export default "__VITE_ASSET__D_iDcfab__"